module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_VII",
      "title": "VII"
    }
  }, [_c('h1', {
    staticClass: "pre_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "fig-004",
      "src": "images/fig_3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "auteur"
  }, [_c('img', {
    staticClass: "image_intext",
    attrs: {
      "alt": "Illustration",
      "id": "fig-005",
      "src": "images/BG_block_paul_color.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("A")]), _vm._v(" great deal of Pauline water, indeed a veritable flood of Pauline water, has passed under the bridge since the first edition of "), _c('i', [_vm._v("The Paul Quest")]), _vm._v(" appeared in 1998 and then won a biblical studies book of the year award from "), _c('i', [_vm._v("Christianity Today")]), _vm._v(" in 1999."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-001",
      "id": "ap_ntb-001-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" Some very major—and some would say seminal and game-changing—studies on Paul began to appear in 1998, starting with J. D. G. Dunn’s synthesis volume, "), _c('i', [_vm._v("The Theology of Paul the Apostle")]), _vm._v(", followed by a whole series of books on Paul or his thought world by N. T. Wright, climaxing in 2013 with Wright’s magnum opus "), _c('i', [_vm._v("Paul and the Faithfulness of God")]), _vm._v(". This was then unexpectedly followed by a capstone work by E. P. Sanders titled "), _c('i', [_vm._v("Paul: The Apostle’s Life, Letters, and Thought")]), _vm._v(", in 2015, and perhaps the most important study on Paul’s theology of grace in a generation, by John Barclay, titled "), _c('i', [_vm._v("Paul and the Gift")]), _vm._v(", which also appeared in 2015.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What characterizes all these works is that they are very large books indeed, the smallest one being Barclay’s, which is a mere 670-plus pages, with Wright’s volumes clocking in at a hefty 1,700-plus pages. Yes, there have also been a variety of other seminal, more specialized studies on Paul in the last twenty years, but none more "), _c('i', [_vm._v("influential")]), _vm._v(" than these on the field, and it should be noted that they all come from the pens of those who either are British New Testament scholars or spent considerable time, as Sanders did (at Oxford), teaching at British institutions and "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_VIII",
      "title": "VIII"
    }
  }, [_vm._v("imbibing the Pauline air from that side of the pond. But it should not be overlooked that the more apocalyptic reading of Paul’s thought by Ernst Käsemann (see especially his Romans commentary) has borne major fruit in America in Lou Martyn’s landmark Galatians commentary and then in various works by his doctoral student Beverly Gaventa."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#ntb-002",
      "id": "ap_ntb-002-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Also, some of the scholars associated with the “new perspective on Paul,” such as Richard Hays and N. T. Wright, have been especially influential in advocating the reading of the Pauline phrase "), _c('i', [_vm._v("pistis Christou ")]), _vm._v("(literally “faith of Christ”) to refer to Christ’s own faith and faithfulness to God.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Thus it is that the course of Pauline studies in the last twenty years dictates a different approach to the study of Paul than was undertaken in the first "), _c('i', [_vm._v("Paul Quest ")]), _vm._v("book, where I (Ben) focused on three different aspects of the Pauline personality—Paul the Jew, Paul the Roman citizen, and Paul the follower of Christ. In this study, we must focus on the interface between Pauline thought and the Pauline mission, with special attention to the former, because that is where the balance of the discussion has been—taking up topics such as the faith of Christ, or justification, or grace. We will do this by focusing carefully on the contributions of these major works, and related seminal studies, assessing both how they have advanced our understanding of Paul and his thought world, and how they may have gone awry in the course of the deep and helpful probing that characterizes these works. We will consider the new perspective(s) on Paul, the apocalyptic Paul of Martyn and Gaventa (and others), the misreading of Paul’s concepts of righteousness and grace, and much more. We have no illusions that we can cover the whole Pauline waterfront of the last twenty years—there’s simply too much water! But what we can do is assess some of the major studies and contributions that have been and are likely to continue to "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_IX",
      "title": "IX"
    }
  }, [_vm._v("be the most influential for our understanding of the first great Christian theologian and missionary—Paul the apostle to the Gentiles.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As for the division of labor, Ben will be taking on the chapters on Wright and Barclay, while Jason will contribute the chapters on the new perspective in general, on Sanders, on Dunn, and on the apocalyptic Paul. In the final conclusions, we will raise and try to answer some questions about what fresh light all these discussions shed on Paul the man, his mission, and his thought world.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 66
// module chunks = 0